import moment from 'moment';
import { getGlobalStore } from '../pages/AppStore';

const filters = {
    // Context Path를 포함한 URL 생성
    ctxPath(path) {
        const store = getGlobalStore(); // 전역 스토어 가져오기
        const contextPath = store.state.contextPath || '';
        return contextPath + path;
    },

    // Context Path를 제외한 URL 생성
    logicalPath(path) {
        const store = getGlobalStore(); // 전역 스토어 가져오기
        const contextPath = store.state.contextPath || '';
        return (contextPath !== '' && path.startsWith(contextPath)) ? path.slice(contextPath.length) : path;
    },

    // 아이디 정규식(5~20자의 영문 소문자, 숫자와 특수기호(_),(-)만 사용)
    date(value) {
        return moment(value).format('YYYY-MM-DD');
    },

    // 아이디 정규식(5~20자의 영문 소문자, 숫자와 특수기호(_),(-)만 사용)
    dateTime(value) {
        return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },

    bytesToSize(bytes) {

        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

        if (bytes == 0) return '0 Byte';

        var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));

        return Math.trunc((bytes / Math.pow(1024, i)) * 10) / 10 + ' ' + sizes[i];

    },

    //  파일명 확장자 제거
    removeExtension(value) {
        // 마지막 '.'의 위치
        const lastIndex = value.lastIndexOf('.');

        // '.'이 없으면 원본 문자열을 반환
        if (lastIndex === -1) return value;

        // '.' 이전까지의 문자열을 반환
        return value.substring(0, lastIndex);
    }
}

export default filters;